import React from 'react';
import {useRef, useEffect, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignal, faComputer, faMobileRetro, faSatelliteDish, faBell } from '@fortawesome/free-solid-svg-icons';

// User Defined modules and style sheets
import './notificationsItem.css';

function NotificationItem(props) {

    useEffect(() => {
        document.querySelector("img").src = props.data.image[0];
    },[]);

    return(
        <li className='d-flex border-bottom justify-content-start'>
            <div className='d-flex flex-row align-items-center justify-content-center symbol p-3'>
                <FontAwesomeIcon icon={faSatelliteDish} className='fs-3' />
            </div>
            <div className='item-body d-flex flex-column justify-content-start align-items-start ms-4'>
                <div className='item-header d-flex flex-column justify-content-between p-1'>
                    <h3>{props.data.hostname}</h3>
                    <h5 className='mt-2'>{props.data.timestamp}</h5>
                </div>
                <h5>{props.data.message}</h5>
                <div>
                    <img src={props.data.image[0]} alt={`image taken from ${props.data.hostname}`} />
                </div>
            </div>
        </li>
    );
}

export default NotificationItem;